import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { NoItemsWrapper } from '../../Zemplin/General/NoItemsWrapper';
import { ProductTabDefault } from './ProductTabDefault';
import { ZemplinLoaderWrapper } from '../../..';

interface Props {
  products: any;
  isFetching: boolean;
  addToCart: any;
  addToRequest: any;
  visible?: boolean;
  isPriceWithVat: boolean;
}

function ProductList({
  products,
  isFetching,
  addToCart,
  addToRequest,
  isPriceWithVat,
  visible = true,
}: Props) {
  const productsComponent =
    products &&
    products.map((p: any) => (
      <ProductTabDefault
        key={p.product_id}
        product={p}
        addToCart={addToCart}
        addToRequest={addToRequest}
        isPriceWithVat={isPriceWithVat}
      />
    ));

  return (
    <ProductsCardWrapper visible={visible}>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : productsComponent && productsComponent.length > 0 ? (
        productsComponent
      ) : (
        <NoItemsWrapper height={500} text={__('Nenašli sa žiadne produkty')} />
      )}
    </ProductsCardWrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ProductsCardWrapper = styled(FlexRow)<{ visible: boolean }>`
  flex-flow: row wrap;
  margin-bottom: ${({ visible }) => (visible ? rem(24) : 0)};
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
  `};
`;

export { ProductList as ImitradeProductList };
